import * as React from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { GET_LATEST_DELIVERY_FOR_ESTIMATION_ITEMS } from "../../operations/queries/operations/queries/latestDeliveryForEstimationItems.js";
const useLatestDynamicDeliveryEstimation = ({
  queryInputArgs
}) => {
  const { called, loading, data, error } = useQuery(GET_LATEST_DELIVERY_FOR_ESTIMATION_ITEMS, {
    skip: !queryInputArgs?.itemInfo?.length,
    variables: {
      input: {
        estimationItems: queryInputArgs.itemInfo,
        shippingMethodKey: queryInputArgs.shippingMethodKey
      }
    }
  });
  const mapDeliveryEstimationResult = (result) => {
    if (result.latestDeliveryForEstimationItems.__typename === "LatestDeliveryEstimationSuccessResponse") {
      const { result: latestDelivery } = result.latestDeliveryForEstimationItems;
      return {
        earliestDeliveryDate: latestDelivery?.earliestDeliveryDate ?? null,
        latestDeliveryDate: latestDelivery?.latestDeliveryDate ?? null
      };
    }
    if (result.latestDeliveryForEstimationItems.__typename === "DeliveryEstimationsFailureResponse") {
      const { failures } = result.latestDeliveryForEstimationItems;
      failures.forEach((failure) => {
        console.error(
          "useLatestDynamicDeliveryEstimation:",
          failure.__typename === "GenericEstimationFailure" ? failure.message : "Product out of stock failure."
        );
      });
    }
    return void 0;
  };
  return React.useMemo(
    () => ({
      called,
      loading,
      data: data?.latestDeliveryForEstimationItems ? mapDeliveryEstimationResult(data) : void 0,
      error
    }),
    [called, loading, data, error]
  );
};
export {
  useLatestDynamicDeliveryEstimation
};
//# sourceMappingURL=use-latest-dynamic-delivery-estimation.js.map
